const AUTH_FAILURE_STATUSES = [401]
export const isAuthFailureStatus = status => AUTH_FAILURE_STATUSES.includes(Number(status))

export const useAuthFailure = () => {
  const authStore = useAuthStore()
  const route = useRoute()
  const isVisible = useState("auth-failure-visible", () => false)
  const statusCode = useState("auth-failure-status", () => null)
  const returnTo = useState("auth-failure-return-to", () => null)

  const clearSession = () => {
    useCookie("accessToken").value = null
    useCookie("refreshToken").value = null
    useCookie("role").value = null
    useAuthSession().logout()
    useBusinessStore().reset()
  }

  const handleAuthFailure = status => {
    const normalizedStatus = Number(status)
    if (!isAuthFailureStatus(normalizedStatus)) return false

    const hadSession = Boolean(
      authStore.authStore?.token || useCookie("accessToken").value,
    )
    if (!hadSession) return false

    if (!isVisible.value) {
      returnTo.value = route.fullPath
      statusCode.value = normalizedStatus
      isVisible.value = true
    }

    clearSession()
    return true
  }

  const close = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    statusCode,
    returnTo,
    handleAuthFailure,
    close,
  }
}
